import { Helmet } from 'react-helmet-async'
import { useFranchiseData } from '../hooks/useFranchiseData'

export default function SeoDefaults() {
  const { franchiseData } = useFranchiseData()
  const origin = typeof window !== 'undefined' ? window.location.origin : ''

  const organization = franchiseData?.name || 'Chelsea Travel'
  const telephone = franchiseData?.telephone || '+27 61 629 3191'
  const email = franchiseData?.email || 'info@chelseatravel.co.za'
  const logo = franchiseData?.general_logo_url || '/CT-HORIZONTAL-LOGO-BLUE.png'
  const sameAs = [
    franchiseData?.facebook,
    franchiseData?.instagram,
    franchiseData?.linkedin,
  ].filter(Boolean) as string[]

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: organization,
    url: origin || 'https://chelseatravel.co.za',
    potentialAction: {
      '@type': 'SearchAction',
      target: origin ? `${origin}/search?q={search_term_string}` : '/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  }

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: organization,
    url: origin || 'https://chelseatravel.co.za',
    logo,
    email,
    telephone,
    address: franchiseData?.address,
    sameAs,
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
    </Helmet>
  )
}
